export default __webpack_public_path__ + "static/media/Coke Ginger Ale Lemonade Soda Tonic Zero - proportioned_170.de6054ea.jpg";